import { useParams } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'

import { useGlobalContext } from '../../../../context/ContextGlobal'
import {
  addDocument,
  addSubDocument,
  deleteSubDocument,
  getDocument,
  getDocuments,
  getSubDocuments,
  updateDocument,
} from '../../../../firebase/firestore'
import { TryCatch } from '../../../../utils/general'
import { TimestampNowSP, GetDateLabel, DateTimeNow, DataComTraçoParaDataComBarra } from '../../../../utils/dates'
import { TransformationforMask } from '../../../../utils/masks'

export const useClientEventMessage = () => {
  const {
    user,
    setAlerts,
    loading,
    setLoading,
    dataContext,
    setDataContext, // contexto que guarda dados de lista para a pagina
    // infosContext,
    // setInfosContext, // contexto que guarda dados adicionais para a pagina funcionar
    formContext,
    setFormContext, // contexto que guarda dados de formularios da pagina
  } = useGlobalContext()

  const { id } = useParams()

  const chatRef = useRef(null)

  const [hideTags, setHideTags] = useState(false)
  const [search, setSearch] = useState('')
  const [inputMessage, setInputMessage] = useState('')

  const CreateMessagesWithDivisions = (messages) => {
    // Ordena por timestamp
    const sorted = [...messages].sort((a, b) => a.timestamp - b.timestamp)

    let lastDateLabel = null
    const result = []

    sorted.forEach((msg) => {
      const dateLabel = GetDateLabel(msg.timestamp) // usa a função do meu post anterior

      if (dateLabel !== lastDateLabel) {
        // Insere a divisão antes da primeira mensagem desse dia
        result.push({ type: 'division', value: dateLabel })
        lastDateLabel = dateLabel
      }

      // Insere a mensagem normalmente
      result.push(msg)
    })

    return result
  }

  const optionsFilterJobOffer = (formContext?.jobOffers || []).map((job) => ({
    label: `${DataComTraçoParaDataComBarra(job.date)} - ${job.round} - ${job?.position?.name || job?.position?.nome}`,
    value: job.id,
  }))

  const getForm = async () => {
    const getEventData = await getDocument('events', id)
    const eventData = {
      ...getEventData,
      ...getEventData.address,
      statusEvent: getEventData.status,
    }
    const getPositions = await getDocuments('cargos')

    const getJobOffers = await getSubDocuments('events', id, 'jobOffers')

    const jobOffers = getJobOffers
      .filter((job) => job.status !== 'deleted')
      .map((job) => {
        const position = getPositions.find((pos) => pos.id === job.idPosition)

        return { ...job, position }
      })

    // console.log(eventData)
    setFormContext((prev) => ({ ...prev, ...eventData, jobOffers }))
    // console.log(user.user.permissions)
  }

  const getData = async () => {
    const getMessagensEvent = await getSubDocuments('events', id, 'messages')
    setDataContext((prev) => ({ ...prev, messages: getMessagensEvent }))
  }

  const FetchGetDatas = async () => {
    await TryCatch(getData, setLoading, setAlerts)
  }

  const FetchGetForm = async () => {
    await TryCatch(getForm, setLoading, setAlerts)
  }

  const sendMessage = async () => {
    if (!user.user.permissions.messagesEvents_add) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Sem Permissão',
          msg: 'Você não possui permissão para enviar mensagens',
        },
      ])
    }

    const filterJobOffers =
      search?.idsjobOffers?.length > 0 ? search.idsjobOffers : optionsFilterJobOffer.map((op) => op.value)

    // const teste = true

    // if (teste) return
    const newMsg = {
      user: 'admin',
      jobOffers: filterJobOffers,
      message: inputMessage,
      timestamp: TimestampNowSP(),
      name: user.user.nome,
      views: [],
    }

    await addSubDocument('events', id, 'messages', newMsg)

    const newNotificationEvent = {
      title: `${TransformationforMask(formContext?.name, 'title')} - ${formContext?.round}`,
      msg: inputMessage,
      idEvent: id,
      dt_created: DateTimeNow(),
      created_by: user.user.nome || user.user.name,
      jobOffers: filterJobOffers,
    }

    await addDocument('_notificationsEvents', newNotificationEvent)

    await FetchGetDatas()

    await setInputMessage('')
  }

  const HandleSendMessage = async () => {
    await TryCatch(sendMessage, setLoading, setAlerts)
  }

  const deleteMessage = async (msgToDelete) => {
    if (!user.user.permissions.messagesEvents_delete) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Sem Permissão',
          msg: 'Você não possui permissão para deletar mensagens',
        },
      ])
    }

    const idMessage = msgToDelete.id

    await deleteSubDocument('events', id, 'messages', idMessage)

    await FetchGetDatas()
  }

  const HandleDeleteMessage = async (msgToDelete) => {
    const callback = async () => {
      await deleteMessage(msgToDelete)
    }
    await TryCatch(callback, setLoading, setAlerts)
  }

  const findDivisionForTimestamp = (timestamp, allMessages) => {
    let foundDivision = null

    for (const msg of allMessages) {
      if (msg.type === 'division' && msg.timestamp <= timestamp) {
        foundDivision = msg
      }
      if (msg.timestamp > timestamp) {
        break
      }
    }

    return foundDivision
  }

  const dataFiltered = (() => {
    if (search === '') {
      const newMsgs = CreateMessagesWithDivisions(dataContext?.messages || [])

      return newMsgs
    }

    const allMessages = dataContext?.messages || []

    // Filtra as mensagens (ignorando as divisões)
    const filteredMsgs = allMessages
      .filter((msg) => {
        if (msg.type === 'division') return false

        const msgJobOffers = msg?.jobOffers || []
        const filterJobOfers = search?.idsjobOffers || []

        if (filterJobOfers.length === 0) return true

        return msgJobOffers.some((JobOfferId) => filterJobOfers.includes(JobOfferId))
      })
      .filter((msg) => {
        if (msg.type === 'division') return false

        const searchString = `${msg?.type}|${msg.name}|${msg.message}|${msg.value}`.toLowerCase()
        return searchString.includes(search?.search?.toLowerCase())
      })

    // Agrupa por data pra resgatar as divisões certas
    const divisionsMap = new Map()

    filteredMsgs.forEach((msg) => {
      const division = findDivisionForTimestamp(msg.timestamp, allMessages)
      if (division && !divisionsMap.has(division.value)) {
        divisionsMap.set(division.value, division)
      }
    })

    // Junta divisões + mensagens filtradas
    const getMessagensEvent = [...divisionsMap.values(), ...filteredMsgs].sort((a, b) => a.timestamp - b.timestamp)

    const newMsgs = CreateMessagesWithDivisions(getMessagensEvent)

    return newMsgs
  })()

  const blockUnblockMessages = async () => {
    const messages = formContext.messages

    if (messages === 'open') {
      await updateDocument('events', id, { messages: 'closed' })
    } else {
      await updateDocument('events', id, { messages: 'open' })
    }

    FetchGetForm()
  }

  const HandleBlockUnblockMessages = async () => {
    const callback = async () => {
      await blockUnblockMessages()
    }
    await TryCatch(callback, setLoading, setAlerts)
  }

  useEffect(() => {
    FetchGetDatas()
    FetchGetForm()
  }, [])

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight
    }
  }, [dataFiltered])

  return {
    user,
    id,
    loading,
    formContext,
    setFormContext,
    search,
    setSearch,
    dataFiltered,
    chatRef,
    inputMessage,
    setInputMessage,
    HandleSendMessage,
    HandleDeleteMessage,
    HandleBlockUnblockMessages,
    optionsFilterJobOffer,
    hideTags,
    setHideTags,
  }
}
